import { useState, useEffect } from "react";
import api from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { useLanguage } from "@/contexts/LanguageContext";

export default function AdminUsers() {
  const { t } = useLanguage();
  const [users, setUsers] = useState([]);

  useEffect(() => { api.get("/admin/users").then(r => setUsers(r.data)).catch(() => {}); }, []);

  return (
    <Card className="border-border/50" data-testid="admin-users">
      <CardHeader className="pb-3"><CardTitle className="text-lg">{t("admin.tab_members")} ({users.length})</CardTitle></CardHeader>
      <CardContent className="p-0 overflow-x-auto">
        <Table>
          <TableHeader><TableRow><TableHead>{t("members.name")}</TableHead><TableHead>{t("members.email")}</TableHead><TableHead>{t("members.phone")}</TableHead></TableRow></TableHeader>
          <TableBody>
            {users.map(u => (
              <TableRow key={u._id} data-testid="admin-user-row">
                <TableCell className="font-medium text-sm">{u.name}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{u.email}</TableCell>
                <TableCell className="text-sm text-muted-foreground">{u.phone || "—"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
